export class Certification {

    option: string;
    filePath: string;

    constructor(data: any = {}) {
        this.option = data.option || '';
        this.filePath = data.filePath || '';
    }

}



// WEBPACK FOOTER //
// ./src/app/models/association/certification.ts